/**
 * Created by jonas on 2021-02-02.
 */
import {StateMatrix, StateMatrixCoordinate} from "../utils/StateMatrix";
import {TheCageSymbolStates} from "../reels/TheCageSymbol";


export function isTheCageInitData(value:any):value is TheCageInitData {
    return value.betLines !== undefined;
}

export function isTheCageGameData(value:any):value is TheCageGameData {
    return value.betWayWins !== undefined;
}

export interface TheCageData {
    mode:string;
    nextMode:string;
    reels:string[][];
    accumulatedRoundWin:number; // total win
    accumulatedFsWinTimesBet:number;
    accumulatedFsWin:number //bet  * accumulatedFsWinTimesBet
    freespinsLeft:number;
    numberOfFreespinsPlayed:number,
    symbolsAfterTumbleForClient:string[][];
    symbolsAfterTumblePrev:string[][];
    boostedBetPlayed:boolean;
    wasFeatureBuy:boolean;
    featureBuyTimesBetValue:any;
    scatterPositionsEnteringFreespin:number[][];
    birdCollectorsList:BirdCollectorData[];
    cornerCollectorsList:CornerCollectorData[];
    specialSymbolsList:CornerCollectorData[];
    persistantBaseMultiplier:number;
    persistantBaseMultiplierBefore:number;
    bottomMultipliersBefore:[number, number, number];
    bottomMultipliersUpdated:[number, number, number];
    lockMapAfter:boolean[][];
    featuresUsedBefore:boolean[];
    featuresUsedAfter:boolean[];
    featuresActive:boolean[];
    fsLevel:number;
    nBNcollectedInFSBefore:number[];
    nBNcollectedInFSAfter:number[];
    defaultBNLevelsFS:number[];
    symbolSizes:number[][];
    symbolSizesAfterTumble:number[][];
    additionalFSadded:number;
    fsLevelEnterWith: number;
    totalAvalancheRoundWinnings: number;
    totalSpinWinnings:number;
}

export interface SymbolValues {
    [symbolName:string]:{
        3:number, 4:number, 5:number, 6:number, 7: number, 8: number, 9:number
    }
}


export interface TheCageInitData extends TheCageData {
    nextPlayerInteraction:any;
    reelsEnteringFreespin:string[][];
    isRestoreState:boolean;
    symbolValues:SymbolValues;
    reelsNextSpin:string;
    freespinTriggeredThisSpin:boolean;
    wasFeatureBuy:boolean;
    mysterySymbolRevealed:string;
    BN_LEVEL_FS:number[];
    nBNcollectedInFS:number[];
    freespinMeterSizeBefore:number;
    freespinMeterSizeAfter:number;
}


export interface CornerCollectorData {
    affectedArea:[number, number][];
    amountHoldingTimesBet:number;
    locked:boolean;
    reel:number;
    row:number;
}

export interface KillHistoryData {
    amount:number
    attribute:string,
    round:number,
    sym:number, //used serverside
    symName:string
}
export interface BirdCollectorData {
    accumulatedWinAmountTimesBet:number;
    closeNeighbors:[number, number][];
    currentReel:number;
    currentRow:number;
    currentSym:number; //used by server
    hitPoint:number;
    hitPointBefore:number;
    isCollector:boolean;
    isPayer:boolean;
    killHistoryList:KillHistoryData[];
    multiplier:number;
    originalReel:number;
    originalRow:number;
    originalSym:number; //used by server
    performedCollectorThisSpin:boolean;
    performedPayerThisSpin:boolean;
    symName:string;
}

export interface TheCageGameData extends TheCageData {
    allWildMiningPositions:[number, number][][];
    betWayWins:BetWayWin[];
    evaluatedArea:string[][];
    playedBetValue:number;
    featureBet:boolean;
    totalWays:number;
    brokeTheBank:boolean;
    maximumWinAchieved:boolean,
    lockMapBefore:boolean[][];
    lockMapAfter:boolean[][];
    wildMiningMap:boolean[][];
    featuresUsedBefore:boolean[];
    featuresUsedAfter:boolean[];
}

export interface WinWayData {
    betWayWin:BetWayWin,
    winCoordinates:StateMatrixCoordinate[]
}

export interface BetWayWin {
    amount:number;
    length:number;
    mode:string;
    multipliedAmount:number;
    multiplier:number;
    numberOfCombinations:number;
    symbol:string;
}

export interface WinLineData {
    betWayWin:BetWayWin,
    coordinates:StateMatrixCoordinate[],
    matrix:StateMatrix<boolean>
    leftToRight:boolean
}

export interface WinData {
    lines:WinLineData[],
    matrix:StateMatrix<TheCageSymbolStates>
    winWays:number;
    winRatio:number;
    accumulatedWinRatio:number;
    accumulatedWin:number;
}
